import React, { Component } from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// @material-ui/icons
import Passenger from "@material-ui/icons/AirlineSeatReclineExtra";

import SettlementPanel from "./settlementPanel.jsx";

// core components
import Grid from "@material-ui/core/Grid";
import GridContainer from "components/Grid/GridContainer.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
// import CardContent from "components/Card/CardContent.jsx";
import Button from "components/CustomButtons/Button.jsx";
import withMobileDialog from "@material-ui/core/withMobileDialog/index";
import { connect } from "react-redux";
// import {store} from "../../_store";
import { store } from "../../_store/store.js";
import { alertActions, commonActions } from "../../_actions/index.js";
import { commonService } from "../../_services/index.js";
import { appConstants } from "../../_constants/index.js";
// import {commonActions} from "../../_actions";
import { EmptyRecord } from "../../utils/PageUtility";
import CircularProgress from "../../utils/CircularProgress";
import SettlementsTable from "./SettlementsTable"
import CardIcon from "components/Card/CardIcon.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import DownloadIcon from "@material-ui/icons/CloudDownload";
import TokenBalance from "@material-ui/icons/AccountBalanceWalletTwoTone";
// import Token from "@material-ui/icons/AssignmentTurnedIn";
import ShowChart from '@material-ui/icons/ShowChart';
import Money from '@material-ui/icons/Money';

// import TokenOutstanding from "@material-ui/icons/Info";
import dashboardStyle from "assets/jss/material-dashboard-react/views/dashboardStyle.jsx";
import { appHelpers } from "../../_helpers/index.js";
import Modal from "../../utils/Modal";
import WalletChart from "./walletChart";

import { defaultWalletData, setWalletData } from "./chartvariables";

import Tooltip from '@material-ui/core/Tooltip';

const today = new Date();
let aMonthAgo = new Date();
aMonthAgo.setDate(today.getDate() - 30);
const customModalStyle = {
  width: '75%',
  maxWidth: 'none',
  overflow: 'scroll'
};

class Settlements extends Component {

  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      rowsPerPage: 10,
      name: "",
      airlines: "",
      airlineData: [],
      AirlineId: '-1',
      selectValue: " ",
      airports: [],
      airportCode: "-1",
      startDate: aMonthAgo,
      endDate: today,
      dataCount: 0,
      currentPage: 1,
      pageSize: 10,
      requestingSettlements: true,
      totalSettlementCount: 0,
      billablePassengerCount: "",
      pscPaymentSettled: "",
      pscPaymentDue: "",
      walletBalance: "",
      outstandingPSCPayment: 0,
      graphModal: false,
      walletChartData: defaultWalletData,
      minimumThreshold: "",
      airlineName: "",
      outstandingBillablePSC: 0
    };
  }

  componentDidMount() {
    const { user, dispatch } = this.props;
    let { startDate, endDate, pageSize } = this.state;

    const { airports } = store.getState();
    this.fetchAirlines();

    if (user.AppRole === appConstants.ROLES.AIRLINE) {
      let userObj = { ...user };
      let userAirline = { value: userObj.AirlineId, label: userObj.AirlineName };
      this.setState({ AirlineId: userAirline, airlineName: user.AirlineName });
      const payload = {
        AirlineId: user.AirlineId,
        StartDate: startDate,
        EndDate: endDate,
        From: 1,
        Size: pageSize
      };
      this.searchSettlements(1, payload);
    }
    else if (user.AppRole === appConstants.ROLES.AIRPORT_MANAGER) {
      let userObj = { ...user };
      let userLocation = { value: userObj.AirportCode, label: userObj.Location };
      this.setState({ airportCode: userLocation });
      const payload = {
        AirportCode: user.AirportCode,
        StartDate: startDate,
        EndDate: endDate,
        From: 1,
        Size: pageSize
      };
      this.searchSettlements(1, payload);
    } else if (user.Location) {
      let userObj = { ...user };
      let userLocation = { value: userObj.AirportCode, label: userObj.Location };
      this.setState({ airportCode: userLocation });
      const payload = {
        AirportCode: user.AirportCode,
        StartDate: startDate,
        EndDate: endDate,
        From: 1,
        Size: pageSize
      };
      this.searchSettlements(1, payload);
    } else {
      this.searchSettlements(1);
    }
    if (airports) {
      this.setState({ airports })
    } else {
      dispatch(commonActions.getAllAirports());
    }

  }

  // fetch airlines
  fetchAirlines = () => {
    let { airlines } = store.getState()
    const { dispatch } = this.props;

    if (airlines) {
      this.setState({ airlineData: airlines, dataCount: airlines.Count })
    } else {
      dispatch(commonActions.getAllAirlines());
    }
  }

  componentWillReceiveProps = (nextProps) => {
    const { airlines, airports } = nextProps;

    if (airlines) {
      let modifiedAirline = [...airlines];
      let allAirlines = { Airline: "All Airlines", AirlineId: "-1" };
      modifiedAirline.unshift(allAirlines);
      this.setState({ airlineData: modifiedAirline, dataCount: airlines.Count })
    }
    if (airports) {
      let modifiedAirport = [...airports];
      modifiedAirport.unshift({ Name: "All Airports", airportLocation: "-1" });
      this.setState({ airports: modifiedAirport })
    }
  }


  handleGraphModal = () => {
    this.fetchWalletMovementData();
  };

  handleCloseGraphModal = () => {
    this.setState({ graphModal: false });
  };

  handleSelectChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleReactSelectChange = (value, name) => {
    this.setState({ [name.name]: value });
    if (value.value === undefined || value.value === "-1" || value.value === "All Flights") {
      this.setState({ [name.name]: "-1" })
    }
  };

  handleDateChange = (date, target) => {
    let currState = this.state;
    currState[target] = date;
    this.setState(currState);
  };

  loadSettlementsData = (pageNumber) => {
    this.searchSettlements(pageNumber)
  }

  searchSettlements = (pageNumber = 1, payload) => {
    let { AirlineId, startDate, endDate, pageSize, airportCode } = this.state
    const { dispatch, user } = this.props;
    startDate = appHelpers.formatDateSpecific(startDate, "YYYY-MM-DD");
    endDate = appHelpers.formatDateSpecific(endDate, "YYYY-MM-DD");
    if (!payload) {
      payload = {
        StartDate: startDate,
        EndDate: endDate,
        From: pageNumber,
        Size: pageSize
      }

      if (AirlineId !== '-1') {
        payload.AirlineId = AirlineId.value;
      }
      if (airportCode !== '-1') {
        payload.AirportCode = airportCode.value;
      }
    }

    dispatch(alertActions.startRequest())
    commonService.getSettlements(payload)
      .then((res) => {
        dispatch(alertActions.stopRequest())
        let response = res.response
        if (res.status === appConstants.SUCCESS_RESPONSE) {
          this.setState({
            currentPage: pageNumber,
            requestingSettlements: false,
            outstandingPSCPayment: response.Entity.OutstandingPSCPayment,
            settlements: response.Entity.Settlement.Manifest,
            totalSettlementCount: response.Entity.TotalCount,
            billablePassengerCount: response.Entity.BillablePassengers,
            pscPaymentDue: response.Entity.PSCPaymentDue,
            pscPaymentSettled: response.Entity.PSCPaymentSettled,
            walletBalance: response.Entity.WalletBalance,
            minimumThreshold: (response.Entity.MinimumThreshold === null) ? "" : response.Entity.MinimumThreshold,
            airlineName: (user.AirlineName) ? user.AirlineName : (AirlineId !== '-1') ? response.Entity.Airline : "All Airlines",
            outstandingBillablePSC: response.Entity.OutstandingBillablePassenger
          });

          // this.packageWalletData(response.Entity.)
        }
        else if (res.status === appConstants.ERROR_RESPONSE) {
          dispatch(alertActions.error(res.response));
          this.setState({ requestingSettlements: false });
        }
      })
  }

  fetchWalletMovementData = () => {
    let { AirlineId, startDate, endDate } = this.state
    const { dispatch } = this.props;
    // let selectedAirlineId = AirlineId;
    startDate = appHelpers.formatDateSpecific(startDate, "YYYY-MM-DD");
    endDate = appHelpers.formatDateSpecific(endDate, "YYYY-MM-DD");


    let payload
    if (AirlineId !== '-1') {
      payload = {
        AirlineId: AirlineId.value,
        IntervalType: 0,
        StartDate: startDate,
        EndDate: endDate

      }
    }
    else {
      payload = {
        IntervalType: 0,
        StartDate: startDate,
        EndDate: endDate
      }
    }

    dispatch(alertActions.startRequest())
    commonService.getWalletMovementData(payload)
      .then((res) => {
        dispatch(alertActions.stopRequest())
        let response = res.response
        if (res.status === appConstants.SUCCESS_RESPONSE) {

          this.packageWalletData(response.Results);
        }
        else if (res.status === appConstants.ERROR_RESPONSE) {
          dispatch(alertActions.error(res.response));
          this.setState({ requestingSettlements: false });
        }
      })
  }

  packageWalletData = (data) => {
    const { graphModal, startDate, endDate } = this.state
    const { walletChartData } = setWalletData(data, startDate, endDate);
    this.setState({ walletChartData })
    this.setState({ graphModal: !graphModal })
  }

  downloadSettlements = (type, pageNumber = 1) => {
    const { AirlineId, startDate, endDate, airportCode } = this.state
    const { dispatch } = this.props;

    let StartDate = appHelpers.formatDateSpecific(startDate, "YYYY-MM-DD");
    let EndDate = appHelpers.formatDateSpecific(endDate, "YYYY-MM-DD");

    let payload = {
      StartDate: StartDate,
      EndDate: EndDate,
      From: pageNumber,
      Type: type
    };

    if (airportCode !== "-1") {
      payload.AirportCode = airportCode.value;
    }
    if (AirlineId !== "-1") {
      payload.AirlineId = AirlineId.value;
    }

    dispatch(alertActions.startRequest());
    commonService.downloadSettlements(payload)
      .then((res) => {
        dispatch(alertActions.stopRequest());
        let response = res.response
        if (res.status === appConstants.SUCCESS_RESPONSE) {
          if (response.DownloadUrl !== null) {
            appHelpers.downloadFile(response.DownloadUrl, "Settlement Report");
          } else {
            dispatch(alertActions.error(response.Message));
          }
        }
        else if (res.status === appConstants.ERROR_RESPONSE) {
          dispatch(alertActions.error(res.response));
        }

      })
  }

  render() {
    const { classes, requesting, user } = this.props;
    const { airlineData, AirlineId, airlineName, startDate, endDate,
      requestingSettlements, totalSettlementCount, settlements,
      currentPage, pageSize, billablePassengerCount, pscPaymentDue,
      pscPaymentSettled, walletBalance, graphModal,
      minimumThreshold, walletChartData, airports, airportCode,
      outstandingBillablePSC
    } = this.state;

    if (requestingSettlements)
      return (
        <CircularProgress />
      );
    return (
      <div>

        <Modal
          title={"Wallet Balance"}
          content={
            <WalletChart chartData={walletChartData} />

          }
          modalStatus={graphModal}
          handleClose={this.handleCloseGraphModal}
          // modalActionLabel={'Download'}
          // handleModalAction={this.downloadManifestPassenger}
          modalStyle={customModalStyle}
        />

        {/*<LinearProgress variant="determinate" value={this.state.completed} />*/}
        <GridContainer>
          <SettlementPanel
            AirlineId={(this.props.user.AppRole === appConstants.ROLES.AIRLINE ? AirlineId : AirlineId.value)}
            airports={airports}
            airportCode={(this.props.user.AppRole === appConstants.ROLES.AIRPORT_MANAGER) || (user.Location) ? airportCode : airportCode.value}
            user={this.props.user}
            // airline={airlineName}
            data={airlineData}
            selectChange={(e, name) => this.handleReactSelectChange(e, name)}
            startDate={startDate}
            endDate={endDate}
            startLabel='Start Date'
            endLabel='End Date'
            handleDateChange={this.handleDateChange}
            onSearch={this.loadSettlementsData}

          />
        </GridContainer>

        <Grid container >
           <Grid item xs={12} sm={4} md={4} >
            <Grid container>
              {/* <Card className={classes.card} style={{ height: "25rem" }}> */}
              <CardBody>

                <Grid item xs={12} sm={12} md={12}>
                  <Card className={"record-cards"} style={{ marginTop: "14px", marginBottom: "0px"}}>
                    <CardHeader color="warning" stats icon>
                      <CardIcon color="warning" style={{ padding: "0px", marginTop: "7px" }}>
                        <Passenger />
                      </CardIcon>
                      <p className={classes.cardCategory}>Billable Passenger</p>
                      <h3 className={classes.cardTitle}>{billablePassengerCount === "" ? 0 : appHelpers.numberWithCommasOnly(billablePassengerCount)}</h3>
                    </CardHeader>
                    {/* <CardFooter chart /> */}
                  </Card>
                </Grid>


                <Grid item xs={12} sm={12} md={12} >
                  <Card className={"record-cards"}  style={{ marginTop: "10px", marginBottom: "0px" }}>
                    <CardHeader color="success" stats icon>
                      <CardIcon color="success" style={{ padding: "0px", marginTop: "7px" }}>
                        <Money />
                      </CardIcon>
                      <p className={classes.cardCategory}>PSC Amount Value</p>
                      <h3 className={classes.cardTitle}> &#8358; {pscPaymentDue === "" ? 0 : appHelpers.numberWithCommas(pscPaymentDue)}</h3>
                    </CardHeader>
                    {/* <CardFooter chart /> */}
                  </Card>
                </Grid>
              </CardBody>
            </Grid>
          </Grid>
                <Grid item xs={12} sm={4} md={4} className={"col"}>
                  <GridContainer>
                    <CardBody style={{marginRight: "18px"}}>
                <Grid item xs={12} sm={12} md={12}>
                  <Card className={"record-cards"}  style={{ marginTop: "14px", marginBottom: "0px"}}>
                    <CardHeader color="info" stats icon>
                      <CardIcon color="info" style={{ padding: "0px", marginTop: "7px" }}>
                        <Money />
                      </CardIcon>
                      <p className={classes.cardCategory}>PSC Payment Settled</p>
                      <h3 className={classes.cardTitle}>
                        <Tooltip title="Payment settled" placement="left-start">
                          <span>
                            &#8358; {pscPaymentSettled === "" ? 0 : appHelpers.numberWithCommas(pscPaymentSettled)}
                          </span>
                        </Tooltip>
                      </h3>
                    </CardHeader>
                    {/* <CardFooter chart>
                        <TokenOutstanding />
                        <Tooltip title="Outstanding payment" placement="bottom">
                          <span style={{ color: 'red' }}>
                            &#8358; {outstandingPSCPayment === "" ? 0 : appHelpers.numberWithCommas(outstandingPSCPayment)}
                          </span>
                        </Tooltip>

                      </CardFooter>*/}
                  </Card>
                </Grid>
                    <Grid item xs={12} sm={12} md={12} >
                      <Card className={"record-cards"}  style={{ marginTop: "10px", marginBottom: "0px"}}>
                        <CardHeader color="info" stats icon>
                          <CardIcon color="danger" style={{ padding: "0px", marginTop: "7px" }}>
                            <Money />
                          </CardIcon>
                          <p className={classes.cardCategory}>Outstanding Billable Amount</p>
                          <h3 className={classes.cardTitle}>
                          <span style={{color: "#e53935"}}>
                              &#8358; {outstandingBillablePSC === "" ? 0 : appHelpers.numberWithCommasOnly(outstandingBillablePSC)}
                          </span>
                          </h3>
                        </CardHeader>
                        {/* <CardFooter chart>
                        <TokenOutstanding />
                        <Tooltip title="Outstanding payment" placement="bottom">
                          <span style={{ color: 'red' }}>
                            &#8358; {outstandingPSCPayment === "" ? 0 : appHelpers.numberWithCommas(outstandingPSCPayment)}
                          </span>
                        </Tooltip>

                      </CardFooter>*/}
                      </Card>
                    </Grid>
                    </CardBody>
                  </GridContainer>
                </Grid >
          <Grid item xs={12} sm={4} md={4} >
            <Grid container>
              <Grid item xs={12} sm={12} md={12}>
                <Card className={"airline-cards"}  >
                  <CardHeader color="success" stats icon>
                    <CardIcon color="success" style={{ marginTop: "6px" }}>
                      <TokenBalance />
                    </CardIcon>
                    {/* <CardBody> */}
                    <p className={classes.cardCategory}>Airline Name</p>
                    <h3 className={classes.cardTitle}> {airlineName}</h3>
                    {/* </CardBody> */}
                    {/* <CardBody> */}
                    <p className={classes.cardCategory}>Current Balance (&#8358;)</p>
                    {
                      walletBalance >= minimumThreshold &&
                      <h3 className={classes.cardTitle} style={{ color: " #43a047" }}> {walletBalance === "" ? 0 : appHelpers.numberWithCommas(walletBalance)}</h3>
                    }
                    {
                      (walletBalance < minimumThreshold || walletBalance <= 0) &&
                      <h3 className={classes.cardTitle} style={{ color: "#c03c3a" }}> {walletBalance === "" ? 0 : appHelpers.numberWithCommas(walletBalance)}</h3>
                    }
                    {/* </CardBody> */}
                    {/* <CardBody> */}
                    <Grid container>
                      <Grid item xs={2} sm={2} md={2} className="pull-left">
                        <Tooltip title="View Wallet Balance Chart" placement="right-start">
                          <Button justIcon round color="primary" style={{ float: "left" }} onClick={this.handleGraphModal}>
                            <ShowChart style={{ marginTop: "-10px", cursor: "pointer" }} />
                          </Button>
                        </Tooltip>

                      </Grid>

                      {AirlineId !== '-1' && <Grid item xs={10} sm={10} md={10}>

                        <div>
                          <p className={classes.cardCategory}>Minimum Re-order Level</p>
                          <h3 className={classes.cardTitle}>&#8358; {
                            minimumThreshold === "" ? appHelpers.numberWithCommas(0.00) : appHelpers.numberWithCommas(minimumThreshold)}</h3>
                        </div>
                      </Grid>}


                    </Grid>
                    {/* </CardBody> */}
                  </CardHeader>
                  <CardFooter chart>
                    {/* &nbsp; */}
                    {/* <Button type="button" color="primary">View Wallet Balance Chart</Button> */}
                  </CardFooter>
                </Card>
              </Grid>
            </Grid>
          </Grid>
        </Grid>


          {/* Table */}
          <Grid container>
          <Grid item xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="success">
                <h4 className={classes.cardTitleWhite}>Settlement Report</h4>
                <p className={classes.cardCategoryWhite}>
                  Settlement Record for Airlines
                </p>
              </CardHeader>
              <CardBody>
                {!requestingSettlements && totalSettlementCount !== 0 &&

                  <SettlementsTable
                    settlementsData={settlements}
                    currentPage={currentPage}
                    pageSize={pageSize}
                    fetchSettlements={this.searchSettlements}
                    totalSettlementCount={totalSettlementCount}
                  />
                }

                {!requestingSettlements && totalSettlementCount === 0 &&
                  <EmptyRecord message={'No settlement record'} />
                }
              </CardBody>
              {!requestingSettlements && totalSettlementCount !== 0 &&
                <CardFooter chart>
                  <div>
                    <Button onClick={() => this.downloadSettlements('pdf', currentPage)} type="button" color="info" disabled={requesting} >
                      <DownloadIcon />
                      Download PDF
                  </Button>
                    <Button onClick={() => this.downloadSettlements('excel', currentPage)} type="button" color="primary" disabled={requesting}>
                      <DownloadIcon />
                      Download EXCEL
                  </Button>
                  </div>
                </CardFooter>
              }
            </Card>
          </Grid>

        </Grid>


      </div >
    );
  }
}

function mapStateToProps(state, ownProps) {
  const { alert, progress, airlines, user, airports, requesting } = state;
  return {
    alert,
    progress,
    airports,
    airlines,
    user,
    requesting
  };
}
export default connect(mapStateToProps)(withMobileDialog()(withStyles(dashboardStyle)(Settlements)));



// WEBPACK FOOTER //
// ./src/views/Settlement/Index.jsx